import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    item: {
      marginBottom: '32px',
    },
    image: {
      display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
      width: '89%',
      maxWidth: '89%',
      height: 'auto',
      margin: 'auto',
      loading: 'lazy',
    },
    title: {
      padding: theme.spacing(12, 0), // 上下|右左, 上|右左|下, 上|右|下|左
      textAlign: 'center',
      width: '79%',
      maxWidth: '79%',
      margin: 'auto',
      // backgroundColor: '#F00',
    },
    text: {
      padding: theme.spacing(0),
      width: '89%',
      maxWidth: '89%',
      margin: 'auto',
      // backgroundColor: '#0F0',
    },
    offset: theme.mixins.toolbar,
  })
);

function Top() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* 屋根修理: 見出し画像 */}
      <Grid container>
        <Grid
          item
          xs={12}
          className={classes.item}
          style={{
            backgroundImage: 'url("./images/main_visual.jpg")',
            backgroundPosition: '50% 68%', // 画像中央を起点に表示
            backgroundSize: 'cover', // 縦横比を維持しながら全体を覆うように表示
            padding: '1em',

            // 上下左右に中央寄せ
            display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
            alignItems: 'center', // 縦方向に中央寄せ
            justifyContent: 'center', // 横方向に中央寄せ
          }}
        >
          <img
            src="./images/catch_copy@2x.png"
            alt="福島県の屋根修理 お任せください。"
            loading="lazy"
            style={{
              display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
              width: 'auto',
              height: '117px',
              maxHeight: '117px',
              margin: '55.5px 0',
            }}
          />
        </Grid>
      </Grid>

      {/* 1列 */}
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <Typography variant="h5" className={classes.title}>
            私たちは福島県の屋根の専門店です
          </Typography>

          <Typography variant="body1" className={classes.text}>
            しいね産業(株)は、大手ハウスメーカーの屋根工事(瓦、板金、雨ドイ工事、太陽光発電の設置工事)を行なっています。
            また、屋根工事店さんに瓦の卸売りの仕事をしています。屋根と屋根材の材質を熟知していますので、安心して任せて頂くことができます。
          </Typography>
        </Grid>
      </Grid>

      {/* 1-1-2列 */}
      <Grid container>
        <Grid item xs={12} sm={12} lg={6} className={classes.item}>
          {/* 1-2-1列 */}
          <Grid container>
            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <Typography variant="h6" className={classes.title}>
                屋根の修理、雨漏り、太陽光発電をのせるなら ぜひご相談ください
              </Typography>

              <Typography variant="body1" className={classes.text}>
                電話かメールでのアポイント後、お伺いし、工事の内容・価格・手順
                などをご説明させて頂きます。
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <img
                src="./images/process.png"
                alt="process"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} lg={6} className={classes.item}>
          {/* 1-2-1列 */}
          <Grid container direction="row-reverse">
            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <Typography variant="h6" className={classes.title}>
                まずはお電話で、お気軽にご相談ください
              </Typography>

              <Typography variant="body1" className={classes.text}>
                無理な勧誘はいたしません。電話相談、現地調査、お見積りはもちろん、無料です。
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <img
                src="./images/Phone.png"
                alt="お電話"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div className={classes.offset} id="solar" />

      {/* 太陽光発電: 見出し画像 */}
      <Grid container>
        <Grid
          item
          xs={12}
          className={classes.item}
          style={{
            backgroundImage: 'url("./images/taiyoukou.jpg")',
            backgroundPosition: '50% 50%', // 画像中央を起点に表示
            backgroundSize: 'cover', // 縦横比を維持しながら全体を覆うように表示
            padding: '1em',

            // 上下左右に中央寄せ
            display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
            alignItems: 'center', // 縦方向に中央寄せ
            justifyContent: 'center', // 横方向に中央寄せ
          }}
        >
          <img
            src="./images/catch_copy_taiyoukou@2x.png"
            alt="福島県で屋根に太陽光発電をのせるなら"
            loading="lazy"
            style={{
              display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
              width: 'auto',
              height: '162px',
              maxHeight: '162px',
              margin: '33px 0',
            }}
          />
        </Grid>
      </Grid>

      {/* 1列 */}
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <Typography variant="h5" className={classes.title}>
            しいね産業(株)は、太陽光発電の設置によく熟知しております
          </Typography>

          <Typography variant="body1" className={classes.text}>
            屋根に太陽光発電をのせる時には、後々、屋根に問題がおきないように、屋根を痛めて雨漏り等をおこさないように、充分な注意を払うことが肝心です。
            その点、当社は屋根専門で、よく屋根と屋根材の材質を熟知していますので、安心して任せて頂くことが出来ます。
          </Typography>
        </Grid>
      </Grid>

      {/* 1-1-3列 */}
      <Grid container>
        <Grid item xs={12} sm={12} lg={4} className={classes.item}>
          {/* 1-2-1列 */}
          <Grid container>
            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <Typography variant="h6" className={classes.title}>
                技術、価格、アフターに、自信を持っています
              </Typography>
              <Typography variant="body1" className={classes.text}>
                大手ハウスメーカーの下請けとして、太陽光発電を屋根にのせる仕事をしてきました。それだけ技術、価格、アフターに、自信を持っています。
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <img
                src="./images/img_taiyoukou_01.png"
                alt="太陽光発電"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} lg={4} className={classes.item}>
          {/* 1-2-1列 */}
          <Grid container direction="row-reverse">
            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <Typography variant="h6" className={classes.title}>
                投資金額の早期回収に協力いたします
              </Typography>
              <Typography variant="body1" className={classes.text}>
                太陽光発電システムは、高価な買い物です。しかし、電気料金の支払いが少なくなったり、地球温暖化対策に貢献できたり
                という事を考えると、必ずしも高価ではないと思います。でも投資金額は、早期に回収したいと思いますから、政府の補助金を上手に使って、早期回収を計画して下さい。
                しいね産業(株)も、できるだけ安価に施工して、投資金額の早期回収に協力いたします。
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <img
                src="./images/img_taiyoukou_02.png"
                alt="太陽光発電 2"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} lg={4} className={classes.item}>
          {/* 1-2-1列 */}
          <Grid container>
            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <Typography variant="h6" className={classes.title}>
                まずはお電話で、お気軽にご相談ください
              </Typography>
              <Typography variant="body1" className={classes.text}>
                無理な勧誘はいたしません。電話相談、現地調査、お見積りはもちろん、無料です。
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} lg={12} className={classes.item}>
              <img
                src="./images/Phone.png"
                alt="お電話"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* 1列 */}
      <Grid container>
        <Grid
          item
          xs={12}
          className={classes.item}
          style={{ textAlign: 'center' }}
        >
          <Button
            variant="contained"
            color="primary"
            component="a"
            href="http://kawarayane.exblog.jp"
          >
            しいね産業のブログ
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Top;
